import {
    Box,
    Typography,
    Button,
    useTheme,
    useMediaQuery,
} from "@mui/material";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { images } from 'config/images';
import { useNavigate } from 'react-router-dom';


export const Hero = () => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const navigate = useNavigate();

    return (
        <Box position="relative" width="100%" height={matches ? "70vh" : "60vh"} overflow="hidden">
            {/* Optimized LCP Image */}
            <Box
                component="img"
                src={images.home.hero}
                alt="Hero banner"
                loading="eager"
                {...{ fetchpriority: "high" } as any}
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    zIndex: 0,
                    filter: 'brightness(0.8)',
                }}
            />

            {/* Content Over Image */}
            <Box
                position="relative"
                zIndex={1}
                display="flex"
                alignItems="center"
                justifyContent="center"
                flexDirection="column"
                height="100%"
                color={theme.palette.common.white}
                px={theme.spacing(4)}
            >

                <Button
                    variant="contained"
                    size="large"
                    sx={{
                        marginTop: theme.spacing(2),
                        backgroundColor: theme.palette.secondary.main,
                    }}
                    endIcon={<AttachMoneyIcon />}
                    onClick={() => navigate('/pricing')}
                >
                    view our pricing
                </Button>
            </Box>
        </Box>
    );
};
